// extracted by mini-css-extract-plugin
export default {"wrapper":"Label_wrapper__EnSDQ","description":"Label_description__ecT5a","tooltip":"Label_tooltip__3+SpQ"};